const apiUrl = process.env.REACT_APP_API_URL

export async function getReport(class_id: number, batch: number) {
    const token = localStorage.getItem('token')
    const res = await fetch(`${apiUrl}/report/${class_id}/${batch}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
    const response: ReportItem[] = await res.json()

    return response
}

export interface ReportItem {
    skill: string
    result: Result
}

interface Result {
    achieving: number
    developing: number
    progressing: number
}
